import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$9013 September sidehustle report – or why the React + D3v4 launch was not 6 figures or even 5",
  "description": "",
  "published": "2017-10-04T00:00:00.000Z",
  "redirect_from": ["/blog/9013-september-sidehustle-report-why-the-react-d3v4-launch/swizec/7837"],
  "categories": "Business, Learning, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`MY BUSINESS IS FAILING`}<br parentName="p"></br>{`Oh no wait we're good.`}<br parentName="p"></br><br parentName="p"></br>{`Funny what one good month will do to a linear regression `}<a parentName="p" {...{
          "href": "https://t.co/iqohQ6Esvo"
        }}>{`pic.twitter.com/iqohQ6Esvo`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/915239443337854976"
      }}>{`October 3, 2017`}</a></blockquote>
    <p>{`Didn't I tell you `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/2629-august-sidehustle-report/swizec/7782"
      }}>{`last month`}</a>{` that fitting linear trends to seasonal data was a Bad Idea™? That's why I wasn't worried when the line showed my business was failing and all hope was lost.`}</p>
    <p>{`This sort of thing is why insider trading is bad. Insiders know when trendlines are wrong, and outsiders do not.`}</p>
    <p>{`You read stories online about people who launch their book and make 6 figures in a week. I am not one of those people. My launch was two orders of magnitude more honest.`}</p>
    <p>{`Here's why 👇`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Best sidehustle month ever! $9013 :partyparrot:`}<br parentName="p"></br><br parentName="p"></br>{`Here's how 👉 `}<a parentName="p" {...{
          "href": "https://t.co/lWVpZ5EpOI"
        }}>{`https://t.co/lWVpZ5EpOI`}</a><br parentName="p"></br><br parentName="p"></br>{`Also explains why it wasn't $90,013 😅 `}<a parentName="p" {...{
          "href": "https://t.co/kd3OOH160K"
        }}>{`pic.twitter.com/kd3OOH160K`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/915738664818245632"
      }}>{`October 5, 2017`}</a></blockquote>
    <p>{`I have all the prerequisites for a huge launch:`}</p>
    <ul>
      <li parentName="ul">{`friendly email list of more than 7,000 people`}</li>
      <li parentName="ul">{`a blog/site that gets okay traffic`}</li>
      <li parentName="ul">{`a kickass product`}</li>
      <li parentName="ul">{`people eagerly waiting to give you money`}</li>
      <li parentName="ul">{`somewhat recognizable brand`}</li>
    </ul>
    <p>{`A couple of things went wrong though. First and foremost is that I missed the market. I launched too late.`}</p>
    <p>{`Interest first started drumming up around December last year, and it made pre-orders absolutely amazing. I was making sales left and right, and it was great.`}</p>
    <p>{`Then it took me another 7 months to finish the book. Oops.`}</p>
    <p>{`By the time React+D3v4 launched, half the people who replied to my `}<em parentName="p">{`"Why didn't you buy this?"`}</em>{` email said things like:`}</p>
    <ul>
      <li parentName="ul">{`uhhh… I needed this 6 months ago`}</li>
      <li parentName="ul">{`dude, I've switched teams, we do Angular`}</li>
      <li parentName="ul">{`can you do something with Vue? React is old`}</li>
    </ul>
    <p>{`💩`}</p>
    <p>{`Sell to people when they're ready to be sold to, not 6 months later. This is something I suspected long ago and need to work on. People get into React and D3 and they have immediate need for help. Then, a few months later, they already figured it out and don't need help anymore.`}</p>
    <p>{`The need to learn a piece of tech is time sensitive.`}</p>
    <p>{`Another timing mistake was launching in the last two weeks of August. I suspect people are still in vacation mode and aren't ready to think about work.`}</p>
    <p>{`Should've waited until September. I was late already.`}</p>
    <p>{`I also learned that React+D3 is `}<em parentName="p">{`work`}</em>{` for most people. Not everyone is crazy like me and learns this stuff just for fun.`}</p>
    <p>{`That's one of those important lessons about understanding your market that I often miss. While I like to learn stuff just for the fun of it, most people learn it so they can get better at their job, land that freelancing client, or quickly ramp up after winging their way through an interview or client call.`}</p>
    <p>{`Sales were okay overall, but there's a worrying detail hidden in this graph 👇`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/10/Screen-Shot-2017-10-04-at-09.21.58.png",
        "alt": null
      }}></img></p>
    <p>{`There's no spike.`}</p>
    <p>{`Books and info products often follow the “huge spike followed by meager steady sales” pattern. This is not the sort of product where you can continuously make a hundred sales per day.`}</p>
    <p>{`You launch and make most of your sales for the year. Then, if your book is any good, it gets some float and keeps making a sale or three per day.`}</p>
    <p>{`My launch did not go that way. No big spike anywhere to be seen. There's a few smaller spikes and they combine into one hell of a month, but there's no `}<em parentName="p">{`huge`}</em>{` spike that's 100x a normal day.`}</p>
    <p>{`I don't know why.`}</p>
    <p>{`But I think it has to do with the 2nd most common reply people gave me:`}</p>
    <p><em parentName="p">{`"Dude, I love your stuff, but I don't need it just yet. When I'm ready and have time, I'll buy, I promise"`}</em></p>
    <p>{`Five bucks says you won't remember 😉`}</p>
    <p>{`Here's where people who are smarter than me introduce artificial scarcity. Something that pushes people over the edge and makes them hit the buy button even if they don't need something just yet.`}</p>
    <p>{`I've certainly done that before. OH YOU HAVE A COOL THING THAT IS USEFUL TO MY LIFE AND I DON’T HAVE TIME BUT YOU’RE TAKING IT AWAY IN TWO DAYS!!? `}<strong parentName="p">{`YES → BUY`}</strong></p>
    <p>{`I didn't have one of those because I think it's gimmicky. Next tim,e I'll have it and try to do it un a nongimmicky way.`}</p>
    <h2 {...{
      "id": "key-takeaways"
    }}>{`Key takeaways`}</h2>
    <p>{`There are two action items from what I've learned during this launch:`}</p>
    <ol>
      <li parentName="ol">{`Have a rolling launch. Run launch activities every 3 months or so. Try to automate this.`}</li>
      <li parentName="ol">{`Set up a time limit to encourage people to buy `}<em parentName="li">{`now`}</em>{`, not later when they forget`}</li>
    </ol>
    <hr></hr>
    <p>{`Here's September in numbers 👇`}</p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $9013`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong>{` $5845`}</p>
    <ul>
      <li parentName="ul">{`React+D3v4: $5785`}</li>
      <li parentName="ul">{`ES6 Cheatsheet: $32`}</li>
    </ul>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $312`}</p>
    <ul>
      <li parentName="ul">{`React + D3: $33`}</li>
      <li parentName="ul">{`React + D3v4: $231`}</li>
      <li parentName="ul">{`Why Programmers Work at Night: $47`}</li>
    </ul>
    <p><strong parentName="p">{`Packt Royalties:`}</strong>{` $722`}</p>
    <p><strong parentName="p">{`React Native School:`}</strong>{` $1905`}</p>
    <p><strong parentName="p">{`Patreon subscriptions:`}</strong>{` $254`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 69 hours`}</p>
    <p><strong parentName="p">{`Expenses:`}</strong></p>
    <ul>
      <li parentName="ul">{`Editor: $500`}</li>
      <li parentName="ul">{`VA: $400`}</li>
      <li parentName="ul">{`Facebook ads: $674`}</li>
      <li parentName="ul">{`FrontApp: $360`}</li>
      <li parentName="ul">{`Drop: $184`}</li>
      <li parentName="ul">{`SumoMe: $99`}</li>
      <li parentName="ul">{`Webfaction: $10`}</li>
      <li parentName="ul">{`LiveEdu Pro: $10`}</li>
      <li parentName="ul">{`Breakthrough Advertising book: $135`}</li>
      <li parentName="ul">{`AWS: $14`}</li>
      <li parentName="ul">{`now.sh: $15`}</li>
    </ul>
    <p>{`Can't wait to get that `}<a parentName="p" {...{
        "href": "https://www.breakthroughadvertisingbook.com/"
      }}>{`Breakthrough Advertising book`}</a>{`. Soooo many people have recommended it, and it's supposed to be the absolute best anyone has ever written on the topic. Straight outta 1966.`}</p>
    <p><strong parentName="p">{`Hourly rate after expenses:`}</strong>{` $102/hour`}</p>
    <p>{`Now we're talking 🤘`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/10/l1ghtsab3r-partyparrot.gif",
        "alt": null
      }}></img></p>
    <p><em parentName="p">{`That's`}</em>{` why I sidehustle: Time stays constant, revenue goes up.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      